import { render, staticRenderFns } from "./TabListHeader.vue?vue&type=template&id=2e7198c6&scoped=true&"
import script from "./TabListHeader.vue?vue&type=script&lang=js&"
export * from "./TabListHeader.vue?vue&type=script&lang=js&"
import style0 from "./TabListHeader.vue?vue&type=style&index=0&id=2e7198c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7198c6",
  null
  
)

export default component.exports